import React from 'react';
import { motion } from 'framer-motion';

const Products = () => {
  return (
    <section id="products" className="py-20 px-6 bg-gray-800 text-gray-100">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto text-center mb-12"
      >
        <h2 className="text-3xl font-bold">Our Products</h2>
        <p className="mt-4">
          Cutting-edge solutions designed to bring real-time communication and
          intelligent functionality to communities.
        </p>
      </motion.div>

      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        <motion.div
          whileHover={{ scale: 1.05 }}
          className="bg-gray-900 rounded-lg p-6 shadow-lg"
        >
          <h3 className="text-2xl font-semibold mb-2">
            Live Azan Broadcasting System
          </h3>
          <p className="mb-4">
            A smart streaming system that connects Masjid to homes in real-time,
            delivering high-quality Azan and announcements using optimized
            low-bandwidth communication technology.
          </p>
          <ul className="list-disc list-inside space-y-1 text-gray-300">
            <li>Real-time streaming</li>
            <li>Low network optimization</li>
            <li>Secure communication</li>
            <li>Dedicated hardware device</li>
          </ul>
        </motion.div>
      </div>
    </section>
  );
};

export default Products;
